import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { useDateTimeService, DEFAULT_FORMAT } from '../../../../../utils/hooks/useDateService';
import DefaultFilterInputLayout from './DefaultFilterInputLayout';
import FilterActions from './FilterActions';
import { useListContext } from '../../../../ListContext';
import { FilterCondition } from 'framework/types';
import { Box } from '@mui/material';

const SingleDateFilterLayout = ({
  source,
  label,
  children,
  dateValue,
  onChangeCallback,
  className,
  onResetFilterCallback,
  popperPlacement,
  condition = FilterCondition.EQ,
  dateFormat = DEFAULT_FORMAT,
}: any) => {
  const { filter: listFilter = {} } = useListContext();
  const { getLocalDate } = useDateTimeService();
  const [isMenuOpened, setIsMenuOpen] = useState(false);

  const formatDate = useCallback(
    (value: string, format = dateFormat) => {
      return value && getLocalDate(value).isValid() ? getLocalDate(value).format(format) : '';
    },
    [getLocalDate, dateFormat],
  );

  const dateInputProps = {
    label: '',
    showCalendar: true,
    className: 'filter-datepicker',
  };

  const dateInputs = React.Children.toArray(children) as React.ReactElement[];

  const toggleMenu = () => {
    if (isMenuOpened) {
      resetFilterChanges();
    }

    setIsMenuOpen(prevValue => !prevValue);
  };

  const resetFilterChanges = useCallback(() => {
    const previousFilterValue = listFilter[source] || {};

    onChangeCallback({
      [condition]: formatDate(previousFilterValue[condition]),
    });
  }, [listFilter, source, onChangeCallback, condition, formatDate]);

  return (
    <DefaultFilterInputLayout
      label={label}
      displayedValue={dateValue}
      isOpen={isMenuOpened}
      toggleMenu={toggleMenu}
      source={source}
      className={classnames('daterange-button-dropdown', className)}
      onResetFilterCallback={onResetFilterCallback}
      popperPlacement={popperPlacement}
    >
      <Box
        className="daterange-input"
        sx={{
          display: 'flex',
          width: '100%',
          padding: '14px 16px 7px',
          '& .MuiFormControl-root': {
            margin: 0,
            '& .MuiFormHelperText-root': {
              marginLeft: 0,
              marginRight: 0,
              marginBottom: '3px',
              fontSize: '11px',
              lineHeight: 1.4,
            },
          },
          '& .MuiInputBase-root': {
            padding: 0,
            '& input': { padding: '10px 12px' },
          },
        }}
      >
        {React.cloneElement(dateInputs[0], dateInputProps)}
      </Box>

      <FilterActions
        onChangeCallback={() => {
          setIsMenuOpen(false);
        }}
        onResetCallback={toggleMenu}
      />
    </DefaultFilterInputLayout>
  );
};

export default SingleDateFilterLayout;
